'use client';

import { useState } from 'react';
import { Info } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { AdaptivePopover } from './adaptive-popover';

/** An (i) that says what a figure counts, in a popover or a sheet on phones. */
export function InfoButton({ label, text }: { label: string; text: string }) {
  const tCommon = useTranslations('common.dialog');
  const [open, setOpen] = useState(false);
  return (
    <AdaptivePopover
      open={open}
      onOpenChange={setOpen}
      title={label}
      closeLabel={tCommon('close')}
      focusTitle
      sheetClose
      trigger={
        <button
          type="button"
          aria-label={label}
          className="-my-2.5 grid size-11 shrink-0 cursor-pointer place-items-center rounded-full text-muted-foreground outline-none hover:text-foreground focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-(--sc-ring)"
        >
          <Info aria-hidden className="size-4" />
        </button>
      }
    >
      <p className="text-sm text-muted-foreground">{text}</p>
    </AdaptivePopover>
  );
}
